import styled from 'styled-components'
import { VerticalCol } from '../../utils/Grid'
import { SIZES } from '../../../constants'

export default styled(VerticalCol)`

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    flex: 0 0 50%;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }

  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    overflow: hidden;
  }
`
